import React, { Component } from "react";
import View from "./view";
import "./index.css";
import { getStoreMachines, getStoreTools } from "../../../backend/machines";
import { withRouter } from "react-router-dom";
import { getStore } from "../../../backend/stores";
import { connect } from "react-redux";
import { updateRoute, select } from "../../../redux/actions";
import { getUser } from "../../../backend/storage";

class MachineList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      machines: [],
      tools: [],
      storeLocation: "",
      loading: false,
      storeSelect: null,
      machineSwapId: null,
      toolSwapId: null,
      hireDetails: [],
    };
    this._change = this._change.bind(this);
    this._navigate = this._navigate.bind(this);
    this._selectStore = this._selectStore.bind(this);
    this._selectMachine = this._selectMachine.bind(this);
    this._selectTool = this._selectTool.bind(this);
    this._closeSwapDialog = this._closeSwapDialog.bind(this);
    this._closeHireDetailDialog = this._closeHireDetailDialog.bind(this);
    this._showOnHiredInfo = this._showOnHiredInfo.bind(this);

  }

  async componentDidMount() {
    const user = await getUser();
    if (this.props.match.params.store_id) {
      this.setState({ loading: true });
      let store = await getStore(this.props.match.params.store_id);
      this.setState({
        machines: await getStoreMachines(this.props.match.params.store_id),
        tools : await getStoreTools(this.props.match.params.store_id),
        storeSelect: { label: store.name, value: store.id },
        store,
        loading: false,
        user
      });
    } else {
      this.setState({ user });
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    if (prevProps.match.params.store_id !== this.props.match.params.store_id) {
      this.setState({ loading: true });

      let store = await getStore(this.props.match.params.store_id);

      this.setState({
        storeSelect: { label: store.name, value: store.id },
        machines: await getStoreMachines(this.props.match.params.store_id),
        tools : await getStoreTools(this.props.match.params.store_id),
        loading: false,
        store
      });
    }
  }

  _selectStore({ label, value, use_app }) {
    this.setState({ storeSelect: { label, value, use_app } });
    this.props.updateRoute(value);
    this._navigate(`/machines/${value}`)();
  }

  _showOnHiredInfo(machine){
    // only technician  can see the hired machine, tool details (customer info)
    if (this.state.user.type.name !== "Merchandiser") {
      this.setState({showHireDetailOverlay : true, hireDetails: machine.hire_details}, ()=>{
      })
    }
  }

  render() {
    return View.call(this);
  }

  async _closeSwapDialog(event, refresh = false) {
    if (!refresh) {
      this.setState({ showSwapOverlay: false});
    } else {
      this.setState({ loading: true });
      this.setState({
        machines: await getStoreMachines(this.props.match.params.store_id),
        loading: false,
        showSwapOverlay: false,
      });
    }
  }

  async _closeHireDetailDialog(event, refresh = false) {
    if (!refresh) {
      this.setState({ showHireDetailOverlay : false });
    } else {
      this.setState({ loading: true });
      this.setState({
        machines: await getStoreMachines(this.props.match.params.store_id),
        loading: false,
        showHireDetailOverlay: false,
        hireDetails: {}
      });
    }
  }

  _change(prop) {
    return event => this.setState({ [prop]: event.target.value });
  }

  _renderMachine( {machine_id, machine_code,machine_status = "No status", last_inspection_date,machine_hours ,hire_details} , key) {
      return (
        <div
            key={key}
            className={`machine ${machine_status.replace(" ", "-")}`}
            onClick={ ()=>{
              (machine_status === 'On Hire' || machine_status === 'Overdue') 
              ? this._showOnHiredInfo({machine_id, machine_code,machine_status,machine_hours,last_inspection_date, hire_details}) 
              : machine_status !== 'In Transit' ? this._selectMachine({machine_id, machine_code,machine_status,machine_hours,last_inspection_date}) : false 
            }
          }
          >
          <div className="id">{machine_code}</div>
          <div className="status">{machine_status}</div>
          <div className="last-inspection">
            {last_inspection_date || "Never inspected"}
          </div>
        </div>
      );
    }

  _renderTool({tool_id,tool_code,tool_status = "No status",last_inspection_date,hire_details}, key) {
    return (
      <div
          key={key}
          className={`machine ${tool_status.replace(" ", "-")}`}
          onClick={()=>{
            (tool_status === 'On Hire' || tool_status === 'Overdue')
            ? this._showOnHiredInfo({tool_id,tool_code,tool_status,last_inspection_date, hire_details}) 
            : tool_status !== 'In Transit' ? this._selectTool({tool_id,tool_code,tool_status,last_inspection_date}) : false
            }
          }
        >
        <div className="id">{tool_code}</div>
        <div className="status">{tool_status}</div>
        <div className="last-inspection">
          {last_inspection_date || "Never inspected"}
        </div>
      </div>
    );
  }

  _selectMachine(machine) {
    this.props.selectMachine(machine);
    if (this.state.user.type.type === "Merchandiser") {
      this._navigate(`/machine-history/${machine.machine_id}`)();
    } else {
      this._navigate(`/machine-form/${machine.machine_id}`)();
    }
  }

  _selectTool(tool) {
    this.props.selectTool(tool);
    if (this.state.user.type.type === "Merchandiser") {
      this._navigate(`/tool-history/${tool.tool_id}`)();
    } else {
      this._navigate(`/tool-form/${tool.tool_id}`)();
    }
  }

  _getStoreHours(store) {
    const weekday = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ];

    try {
      const storeHours = store.working_hour[0];

      let currDay = weekday[new Date().getDay()];
      let openingHours = "";
      let closingHours = "";

      Object.keys(storeHours).map(
        hour =>
          hour.includes(currDay.toLowerCase())
            ? hour.includes("close")
              ? (closingHours = storeHours[hour])
              : hour.includes("open")
                ? (openingHours = storeHours[hour])
                : null
            : null
      );
      return (
        <span className="working_hour">
          {openingHours} - {closingHours}
        </span>
      );
    } catch (err) {
      return <span className="working_hour">Could not get opening hours</span>;
    }
  }

  _navigate(location) {
    const { history } = this.props;
    return event => {
      history.push(location);
    };
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateRoute: store_id => {
      dispatch(updateRoute("machines", `/machines/${store_id}`));
      dispatch(updateRoute("stores", `/stores/${store_id}`));
      dispatch(updateRoute("create", `/comment-form/${store_id}`));
    },
    selectMachine: machine => {
      dispatch(select("machine", machine));
    },
    selectTool: tool => {
      dispatch(select("tool", tool));
    }
  };
};

const mapStateToProps = (state, ownProps) => {
  return {};
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(MachineList)
);



// WEBPACK FOOTER //
// ./src/screens/machines/machine-list/index.js